export default "__VITE_ASSET__CmXJ9B4r__"